// src/components/KomebuMobile.js
import React, { useState, useEffect } from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  Menu,
  MenuItem,
  Typography,
  Box,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MapIcon from "@mui/icons-material/Map";
import GroupIcon from "@mui/icons-material/Group";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import RiceBowlIcon from "@mui/icons-material/RiceBowl";
import { doc, getDoc } from "firebase/firestore";
import { db, auth } from "../api/firebase";
import { useNavigate } from "react-router-dom";

import KomebuNewsList from "./KomebuNewsList";
import MapComponent from "./MapComponent";
import KomebuGroupList from "./KomebuGroupList";
import KomebuJoinedGroups from "./KomebuJoinedGroups";
import FarmerListByRegion from "./FarmerListByRegion";
import KomebuRice from "./KomebuRice"; // ← 追加：お米一覧（既存コンポーネント）

const KomebuMobile = () => {
  // タブ番号を統一（0:HOME / 1:お知らせ / 2:マップ / 3:お米 / 4:グループ / 5:農地一覧(管理者)）
  const TAB_HOME = 0;
  const TAB_NEWS = 1;
  const TAB_MAP = 2;
  const TAB_RICE = 3;
  const TAB_GROUP = 4;
  const TAB_FARMLAND = 5;

  const [selectedTab, setSelectedTab] = useState(TAB_NEWS); // 初回は「お知らせ」
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // グループメニュー
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedGroupType, setSelectedGroupType] = useState("グループ一覧");

  useEffect(() => {
    const fetchUserData = async () => {
      const currentUser = auth.currentUser;
      if (currentUser) {
        const userDocRef = doc(db, "users", currentUser.uid);
        const snap = await getDoc(userDocRef);
        if (snap.exists()) setUser(snap.data());
      }
    };
    fetchUserData();
  }, []);

  const handleGroupClick = (event) => setAnchorEl(event.currentTarget);
  const handleCloseGroupMenu = (groupType) => {
    setAnchorEl(null);
    if (groupType) {
      setSelectedGroupType(groupType);
      setSelectedTab(TAB_GROUP); // グループタブを表示
    }
  };

  const renderContent = () => {
    switch (selectedTab) {
      case TAB_NEWS:
        return <KomebuNewsList user={user} />;
      case TAB_MAP:
        return <MapComponent />;
      case TAB_RICE:
        return <KomebuRice user={user} />; // ← ここでお米一覧を表示
      case TAB_GROUP:
        return selectedGroupType === "グループ一覧" ? (
          <KomebuGroupList user={user} />
        ) : (
          <KomebuJoinedGroups user={user} />
        );
      case TAB_FARMLAND:
        return <FarmerListByRegion user={user} />;
      default:
        return null;
    }
  };

  const handleTabChange = (event, newValue) => {
    if (newValue === TAB_HOME) {
      navigate("/home");
      return;
    }
    if (newValue === TAB_GROUP) {
      // グループはメニューを開く（表示はTAB_GROUPのまま）
      setAnchorEl(event.currentTarget);
      setSelectedTab(TAB_GROUP);
      return;
    }
    setSelectedTab(newValue);
  };

  return (
    <div>
      {/* メイン */}
      <main style={{ paddingBottom: "56px" }}>
        <Box>{renderContent()}</Box>
      </main>

      {/* BottomNavigation */}
      <BottomNavigation
        value={selectedTab}
        onChange={handleTabChange}
        showLabels
        style={{ position: "fixed", bottom: 0, width: "100%", zIndex: 1000 }}
        sx={{
          "& .MuiBottomNavigationAction-root": {
            minWidth: "auto",
            padding: "4px 6px",
          },
          justifyContent: "center",
        }}
      >
        <BottomNavigationAction label="HOME" icon={<HomeIcon />} value={TAB_HOME} />
        <BottomNavigationAction label="お知らせ" icon={<NotificationsIcon />} value={TAB_NEWS} />
        <BottomNavigationAction label="マップ" icon={<MapIcon />} value={TAB_MAP} />
        {/* ★ 追加：お米タブ */}
        <BottomNavigationAction label="お米" icon={<RiceBowlIcon />} value={TAB_RICE} />
        <BottomNavigationAction
          label="グループ"
          icon={<GroupIcon />}
          value={TAB_GROUP}
          onClick={handleGroupClick}
        />
        {user?.isAdmin && (
          <BottomNavigationAction label="農地一覧" icon={<AgricultureIcon />} value={TAB_FARMLAND} />
        )}
      </BottomNavigation>

      {/* グループ選択メニュー */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleCloseGroupMenu(null)}
      >
        <MenuItem onClick={() => handleCloseGroupMenu("グループ一覧")}>グループ一覧</MenuItem>
        <MenuItem onClick={() => handleCloseGroupMenu("参加グループ")}>参加グループ</MenuItem>
      </Menu>
    </div>
  );
};

export default KomebuMobile;
